module.exports = __webpack_public_path__ + "images/Car-62aed044a9964a4f3597a4313328a7b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Car.jpg
// module id = 24
// module chunks = 0